import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { isOnlineState } from '../recoil/atoms';

export const NetworkStatusEffects = () => {
  const setIsOnline = useSetRecoilState(isOnlineState);

  const handleNetworkStatusChange = () => setIsOnline(navigator.onLine);

  useEffect(() => {
    window.addEventListener('offline', handleNetworkStatusChange);
    window.addEventListener('online', handleNetworkStatusChange);
    return () => {
      window.removeEventListener('offline', handleNetworkStatusChange);
      window.removeEventListener('online', handleNetworkStatusChange);
    };
  }, []);

  return <></>;
};
